import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// Components
import ChassisPoolsDropdown from '../../dropdowns/ChassisPoolsDropdown';
import Checkbox from 'shared/inputs/BaseCheckbox';
import FieldsToSelectDropdown from './components/FieldsToSelectDropdown';
import { getChassisPoolsLookup } from 'src/fetch/chassisPool';
import { getChassisPools, setChassisPools } from 'src/slices/chassisPools';
// Helpers
import { has } from 'lodash';

const ChassisPoolFilter = ({
  filter, onFilterChange, fieldsNameForSearch, collection, fieldInfo,
}) => {
  const { value } = filter;
  const dispatch = useDispatch();
  const chassisPools = useSelector(getChassisPools);
  const [displayValue, setDisplayValue] = useState(!filter.compareWithOtherField ? value : null);
  const [compareWithOtherFieldDisplayValue, setCompareWithOtherFieldDisplayValue] = useState(
    filter.compareWithOtherField ? value : null,
  );
  const [compareWithOtherField, setCompareWithOtherField] = useState(filter.compareWithOtherField);

  const onChange = (event) => {
    const newFilter = {
      ...filter,
      value: event.target.value.value,
      fieldMetadata: {
        collection,
      },
      fieldInfo,
    };
    delete newFilter.compareWithOtherField;

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setDisplayValue(event.target.value);
  };

  useEffect(() => {
    setCompareWithOtherField(filter.compareWithOtherField);
  }, [filter.compareWithOtherField]);

  useEffect(() => {
    const setValue = filter.compareWithOtherField ? setCompareWithOtherFieldDisplayValue : setDisplayValue;
    setValue(value);
  }, [value]);

  useEffect(() => {
    if (!has(filter, 'fieldInfo')) {
      onFilterChange.call(undefined, {
        nextFilter: {
          ...filter,
          fieldInfo,
        },
      });
    }
  }, []);

  const handleFieldToCompareChanged = (event) => {
    const value = event.target.value.field;

    const newFilter = {
      ...filter,
      value,
      compareWithOtherField: true,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setCompareWithOtherFieldDisplayValue(event.target.value);
  };

  const handleCompareWithOtherFields = ({ value }) => {
    const newFilter = value ? {
      ...filter,
      value: typeof compareWithOtherFieldDisplayValue === 'object'
        ? compareWithOtherFieldDisplayValue?.field : compareWithOtherFieldDisplayValue,
      compareWithOtherField: true,
      fieldMetadata: {
        collection,
      },
      fieldInfo,
    } : {
      field: filter.field,
      operator: filter.operator,
      value: typeof displayValue === 'object' ? displayValue?.value : displayValue,
      fieldMetadata: {
        collection,
      },
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    const setValue = !value ? setCompareWithOtherFieldDisplayValue : setDisplayValue;
    setValue(null);
    setCompareWithOtherField(value);
  };

  useEffect(() => {
    if (!chassisPools || chassisPools.length === 0) {
      getChassisPoolsLookup().then((data) => dispatch(setChassisPools({ chassisPools: data })));
    }
  }, []);

  return (
    <div className='app-filters-input'>
      {compareWithOtherField && fieldsNameForSearch.length > 0
        ? (
          <FieldsToSelectDropdown
            fields={fieldsNameForSearch}
            onFieldChanged={handleFieldToCompareChanged}
            value={compareWithOtherFieldDisplayValue}
          />
        ) : (
          filter.operator !== 'isnull' && filter.operator !== 'isnotnull'
        ) && <ChassisPoolsDropdown onChange={onChange} value={displayValue} clearButton={false} />}
      {fieldsNameForSearch.length > 0 && (
        <div className='filter-cbx-wrapper'>
          <Checkbox
            value={compareWithOtherField}
            label='Compare with other field'
            onChange={handleCompareWithOtherFields}
          />
        </div>
      )}
    </div>
  );
};

export default ChassisPoolFilter;
